import React, { useEffect, useMemo, useState } from 'react'
import classes from "./PricingNewpayment.module.css";
import promix from "../../Assets/Promix.svg"
import deletes from "../../Assets/delete.svg"
import credtcrd from "../../Assets/Credit Card.png"
import excelIcon from "../../Assets/excelIcon.svg"
import exitIcon from "../../Assets/exitIcon.svg"
import downloadTemplate from "../../Assets/downloadTemplate.svg"
import uploadTemplate from "../../Assets/uploadTemplate.svg"
import checkBox from "../../Assets/checkbox.svg"
import upIgo from "../../Assets/upigo.svg"
import downloadgo from "../../Assets/downloadddd.svg"
import manualIcon from "../../Assets/manualIcon.svg"
import wallet from "../../Assets/wallet-03.png"
import card from "../../Assets/credit-card-01.png"
import lock from "../../Assets/lock.png"
import arrowleft from "../../Assets/arrow-left.png"
import marked from "../../Assets/tick.png"
import star from "../../Assets/star.svg"
import { Button, Modal, Form, Spinner, Tab, Tabs, Row, Col, Popover } from 'react-bootstrap';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import axios from "axios";
import { BASE_URL } from "../../Components/API/Api";
import api, { withCompanyId } from "../../Components/API/Api";
import Swal from "sweetalert2";
import { useUser } from '../../UserContext';

const UploadOpeningBal = () => {
    const [showPaystackModal, setShowPaystackModal] = useState(false);
    const [showSuccessModal, setShowSuccessModal] = useState(true);
    const [showAcctModal, setShowAcctModal] = useState(false);
    const [createLoading, setCreateLoading] = useState(false);
    const [balanceLoading, setBalanceLoading] = useState(false);
    const [selectedDate, setSelectedDate] = useState('');   
    const [selectedFile, setSelectedFile] = useState(null);
    const [selectedFileName, setSelectedFileName] = useState("");
    const [balances, setBalances] = useState([]);
    const handleShowSuccessModal = () => setShowSuccessModal(true);
    const handleShowAcctModal = () => {
    setShowAcctModal(true);
    setShowSuccessModal(false);
    };
    const handleCloseAcctModal = () => setShowAcctModal(false);
    const handleCloseSuccessModal = () => setShowSuccessModal(false);
    const [successSummary, setSuccessSummary] = useState(null);
    const [showDeclinedModal, setShowDeclinedModal] = useState(false);
    const [showDownloadExcel, setShowDownloadExcel] = useState(false);
    const [showUploadExcel, setShowUploadExcel] = useState(false);
    const [showAccountDetailsModal, setShowAccountDetailsModal] = useState(false);
    const [paymentMethod, setPaymentMethod] = useState("paystack");
    const [savingAccountsLoading, setSavingAccountsLoading] = useState(false);
    // Dummy wallet account details
    const [accountDetails, setAccountDetails] = useState({ accountName: 'Demo User', accountNumber: '9876543210', bank: 'DemoBank' });
    // Dummy wallet balance (set to 0 for insufficient funds test)
    const [walletBalance, setWalletBalance] = useState(0);
    const location = useLocation();
    const navigate = useNavigate();
    const [rows, setRows] = useState([
        { accountName: "", accountCode: "", description: "", debit: "", credit: "", showDropdown: false }
    ]);
    const [downloadingTemplate, setDownloadingTemplate] = useState(false);
    const [accountTypes, setAccountTypes] = useState([]);
    const [loadingTypes, setLoadingTypes] = useState(false);
    const [accountsLoading, setAccountsLoading] = useState(false);
    const [accounts, setAccounts] = useState([]);
    const { login, setActiveCompany } = useUser();
    const selectedPlan = location.state?.selectedPlan;
    const searchParams = useMemo(() => new URLSearchParams(location.search), [location.search]);

    useEffect(() => {
        const companyId = location.state?.company_id;
        if (companyId) {
            localStorage.setItem("company_id", String(companyId));
            localStorage.setItem("activeCompanyId", String(companyId));
        }
    }, [location.state?.company_id]);

    const formatMonthlyPrice = (plan) => {
        if (!plan || plan.monthly == null) return "₦0";
        const value = parseFloat(plan.monthly);
        if (Number.isNaN(value)) return "₦0";
        return `₦${value.toLocaleString("en-US", {
            minimumIntegerDigits: 1,
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
        })}`;
    };

      const removeRow = (index) => {
    setRows(prev => prev.length === 1 ? prev : prev.filter((_, i) => i !== index));
  };

//     const addLine = () => {
//     setRows(prev => [
//       ...prev,
//       { accountId: "", accountDisplay: "", description: "", debit: "", credit: "", showDropdown: false },
//     ]);
//   };

const addLine = () => {
  setRows(prev => [
    ...prev,
    {
      accountId: "",
      accountDisplay: "",
      description: "",
      debit: "",
      credit: "",
      showDropdown: false,
      isPrefilled: false, // 👈 user-added rows
    },
  ]);
};  




  const handleChange = (index, field, value) => {
    setRows(prev => {
      const newRows = [...prev];
      const row = { ...newRows[index] };
      if (field === "debit") {
        row.debit = value;
        if (parseFloat(value) > 0) row.credit = "0";
      } else if (field === "credit") {
        row.credit = value;
        if (parseFloat(value) > 0) row.debit = "0";
      } else if (field === "account") {
        row.accountId = value?.id ?? "";
        row.accountDisplay = `${value?.gl_code ?? value?.code ?? ""} - ${value?.gl_name ?? value?.name ?? ""}`;
      } else if (field === "showDropdown") {
        row.showDropdown = value;
      } else {
        row[field] = value;
      }
      newRows[index] = row;
      return newRows;
    });
  };

    const planName = selectedPlan?.name || "Professional";
    const planDescription = selectedPlan?.use || "For growing businesses and small teams";
    const planAmount = selectedPlan ? formatMonthlyPrice(selectedPlan) : "₦25,000";
    const planPrivileges = selectedPlan?.privileges || [
        "5 Users",
        "Advanced Reports",
        "Multi-currency",
        "API Access",
        "Priority Support",
        "Custom Integrations",
        "Automated Workflows",
    ];

      // Fetch accounts
      useEffect(() => {
        const fetchAccounts = async () => {
          const token = localStorage.getItem("authToken");
          if (!token) return;
          setAccountsLoading(true);
          try {
            const res = await api.get('/v1/account/company-accounts');
            let raw = res?.data?.data ?? res?.data ?? [];
            if (Array.isArray(raw.data)) raw = raw.data;
            setAccounts(Array.isArray(raw) ? raw : []);
          } catch (err) {
            console.error("Error fetching accounts:", err);
            setAccounts([]);
          } finally {
            setAccountsLoading(false);
          }
        };
        
        fetchAccounts();
    }, []);

        const token = localStorage.getItem("authToken");

        useEffect(() => {
            const fetchAccountTypes = async () => {
                try {
                    setLoadingTypes(true);

                    const resp = await api.get('/v1/get-sub-categories');

                    const raw = resp?.data?.data ?? resp?.data ?? [];
                    const list = Array.isArray(raw) ? raw : [];

                    setAccountTypes(list);
                } catch (e) {
                    console.error(
                        'Failed to load account types',
                        e?.response?.data || e?.message
                    );
                    setAccountTypes([]);
                } finally {
                    setLoadingTypes(false);
                }
            };

            fetchAccountTypes();
        }, [token]);      
    
      // Populate rows with accounts
    //   useEffect(() => {
    //     if (showAcctModal && accounts.length > 0) {
    //       setRows(accounts.map(acc => ({
    //         accountId: acc.id,
    //         accountName: acc.gl_name ?? acc.name ?? "",
    //         accountCode: acc.gl_code ?? acc.code ?? "",
    //         description: "",
    //         debit: "",
    //         credit: "",
    //         showDropdown: false
    //       })));
    //     }
    //   }, [showAcctModal, accounts]);

        useEffect(() => {
        if (accounts.length > 0) {
            setRows(
            accounts.map(acc => ({
                accountId: acc.id,
                accountName: acc.gl_name ?? acc.name ?? "",
                accountCode: acc.gl_code ?? acc.code ?? "",
                description: "",
                debit: "",
                credit: "",
                showDropdown: false,
                isPrefilled: true, // 👈 add this
            }))
            );
        }
        }, [accounts]);

    
        const saveNewAccounts = async () => {
        try {
            setSavingAccountsLoading(true);

            // get company_id
            const companyId =
            localStorage.getItem("company_id") ||
            localStorage.getItem("activeCompanyId");

            if (!companyId) {
            Swal.fire("Error", "Company ID not found", "error");
            return;
            }

            // only newly added rows
            const newRows = rows.filter((row) => !row.isPrefilled);

            if (newRows.length === 0) {
            Swal.fire("Info", "No new accounts to save", "info");
            return;
            }

            // validate rows
            const invalidRow = newRows.find(
            (row) => !row.accountName || !row.accountCode
            );

            if (invalidRow) {
            Swal.fire(
                "Validation Error",
                "All new rows must have account name and account type",
                "warning"
            );
            return;
            }

            // format payload
            const payload = {
            account_type: newRows.map((row) => row.accountCode),
            account_name: newRows.map((row) => row.accountName),
            company_id: companyId,
            };

            console.log("Payload:", payload);

            const response = await api.post(
            "/v1/create-account-array",
            payload
            );

            if (
            response?.data?.status === true ||
            response?.data?.success === true
            ) {
            Swal.fire(
                "Success",
                "Accounts created successfully",
                "success"
            );

            // navigate to dashboard
            navigate("/dashboard");

            } else {
            Swal.fire(
                "Error",
                response?.data?.message || "Failed to save accounts",
                "error"
            );
            }
        } catch (error) {
            console.error(error);

            Swal.fire(
            "Error",
            error?.response?.data?.message ||
                "Something went wrong",
            "error"
            );
        } finally {
            setSavingAccountsLoading(false);
        }
        };

        const companyId = location.state?.company_id || localStorage.getItem("company_id") || localStorage.getItem("activeCompanyId");
        const companyInfo = JSON.parse(localStorage.getItem("companyInfo"));
        const industryID = localStorage.getItem("selectedIndustryId") || companyInfo?.industry;
        console.log("Industry ID:", industryID);

    

    // Ensure page is scrolled to top whenever this route is navigated to
    useEffect(() => {
        try {
            window.scrollTo(0, 0);
        } catch {
            // ignore if environment doesn't support window scrolling
        }
    }, [location.pathname]);

    // If Paystack redirects back after checkout, show the appropriate modal.
    useEffect(() => {
        // Merge search params and hash params (some gateways use hash fragments)
        const combined = new URLSearchParams(location.search || "");
        if (location.hash) {
            const hashString = location.hash.replace(/^#/, "");
            const hashParams = new URLSearchParams(hashString);
            for (const [k, v] of hashParams.entries()) {
                if (!combined.has(k)) combined.set(k, v);
            }
        }

        const status = (combined.get("status") || combined.get("payment_status") || "").toLowerCase();
        const successFlag = (combined.get("success") || combined.get("paid") || "").toLowerCase();
        const failedFlag = (combined.get("failed") || combined.get("cancelled") || "").toLowerCase();

        const isSuccessFromRedirect =
            status === "success" ||
            status === "successful" ||
            successFlag === "true" ||
            successFlag === "1" ||
            successFlag === "yes";

        const isFailedFromRedirect =
            status === "failed" ||
            status === "failure" ||
            status === "cancelled" ||
            status === "canceled" ||
            failedFlag === "true" ||
            failedFlag === "1" ||
            failedFlag === "yes";

        const referenceParam = combined.get("reference") || combined.get("trxref") || combined.get("tx_ref") || "";
        const treatReferenceAsSuccess = referenceParam && !isFailedFromRedirect;

        // Debug helpers to help during testing
        try {
            console.debug("Payment redirect params:", Object.fromEntries(combined.entries()));
        } catch {}

        if (isSuccessFromRedirect || treatReferenceAsSuccess) {
            console.log("Token after redirect:", localStorage.getItem("token"));
            let foundSummary = null;
            try {
                const raw = localStorage.getItem("pendingPaymentSummary");
                if (raw) foundSummary = JSON.parse(raw);
            } catch (err) {
                console.debug("Failed to read pendingPaymentSummary:", err);
            } finally {
                localStorage.removeItem("pendingPaymentSummary");
            }

            // Prefer explicit display values returned by the backend in query
            // params (so we can show a full summary even if localStorage was
            // cleared). Common keys: `plan`, `plan_name`, `amount`, `amountPaid`.
            const planFromQuery = combined.get('plan') || combined.get('plan_name') || '';
            const amountFromQuery = combined.get('amount') || combined.get('amountPaid') || combined.get('amount_paid') || '';

            const formatAmount = (val) => {
                if (!val) return planAmount;
                const n = Number(String(val).replace(/[^0-9.-]+/g, ''));
                if (Number.isFinite(n)) {
                    const naira = n / 100; // Convert from kobo to naira
                    return `₦${naira.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
                }
                return String(val);
            };

            if (!foundSummary) {
                foundSummary = {
                    plan: planFromQuery || selectedPlan?.name || planName,
                    amountPaid: formatAmount(amountFromQuery) || planAmount,
                    billing: combined.get('billing') || 'Monthly',
                };
            } else {
                // If a saved summary exists but backend provided nicer display
                // values, prefer those.
                if (planFromQuery) foundSummary.plan = planFromQuery;
                if (amountFromQuery) foundSummary.amountPaid = formatAmount(amountFromQuery);
                if (combined.get('billing')) foundSummary.billing = combined.get('billing');
            }

            setSuccessSummary(foundSummary);

            try {
                localStorage.setItem("hasPaidPlan", "true");
            } catch {}

            // setShowSuccessModal(true);
            handleShowSuccessModal();
            // Auto-login the user after successful payment
            void autoLoginUser({ redirectToDashboard: true });
        } else if (isFailedFromRedirect) {
            localStorage.removeItem("pendingPaymentSummary");
            setShowDeclinedModal(true);
        }
    }, [location.search, location.hash]);

    // Load user's auto-generated wallet account details from localStorage
    // Dummy data: skip loading from localStorage for now
    // useEffect(() => {
    //     ...existing code...
    // }, []);

    // Function to auto-login user after successful payment
    const autoLoginUser = async ({ redirectToDashboard } = { redirectToDashboard: false }) => {
        try {
            const userEmail = localStorage.getItem("userEmail");
            const userPassword = localStorage.getItem("userPassword");

            if (!userEmail || !userPassword) {
                console.warn("User credentials not found in localStorage for auto-login");
                return;
            }

            const response = await axios.post(`${BASE_URL}/v1/login`, {
                email: userEmail,
                password: userPassword,
            });

            if (response.data?.status === true || response.data?.success === true) {
                const token = response.data?.data?.token || response.data?.token;
                const userData = response.data?.data?.user || response.data?.user;

                if (token && userData) {
                    const selectedCompanyId = location.state?.company_id || localStorage.getItem("company_id") || localStorage.getItem("activeCompanyId");
                    // Use the login function from UserContext
                    login(userData, token);

                    // Fetch companies and pick one so dashboard requests have company_id
                    try {
                        // Clear any previous company data to avoid conflicts
                        localStorage.removeItem('companyInfo');
                        localStorage.removeItem('companies');

                        const compRes = await axios.get(`${BASE_URL}/v1/companies/get-info`, {
                            headers: {
                                Authorization: `Bearer ${token}`,
                                Accept: "application/json",
                            },
                        });
                        const list = Array.isArray(compRes?.data?.data)
                            ? compRes.data.data
                            : (compRes?.data?.data ? [compRes.data.data] : []);
                        try { localStorage.setItem('companies', JSON.stringify(list)); } catch {}

                        const first = list?.[0] || null;
                        const selectedCompany = list.find(company =>
                            String(company?.id || company?.company_id || company?.companyId) === String(selectedCompanyId)
                        ) || first;
                        const cid = selectedCompanyId || selectedCompany?.company_id || selectedCompany?.id || selectedCompany?.companyId || null;
                        if (cid && typeof setActiveCompany === 'function') {
                            setActiveCompany(String(cid), selectedCompany);
                        } else if (cid) {
                            try { localStorage.setItem('company_id', String(cid)); } catch {}
                            try { localStorage.setItem('activeCompanyId', String(cid)); } catch {}
                            try { localStorage.setItem('companyInfo', JSON.stringify(selectedCompany)); } catch {}
                            try { axios.defaults.headers.common['company_id'] = String(cid); } catch {}
                        }
                    } catch (e) {
                        // If this fails, user is still logged in; dashboard may still work depending on endpoints.
                        console.warn("Failed to fetch/set company after auto-login:", e);
                    }

                    // Clear stored credentials (we only needed them for one-time auto-login)
                    try {
                        localStorage.removeItem("userPassword");
                        localStorage.removeItem("userEmail");
                        localStorage.removeItem("userNIN");
                    } catch {}

                    console.log("User auto-logged in after payment");
                    if (redirectToDashboard) {
                        navigate("/dashboard", { replace: true });
                    }
                } else {
                    console.warn("Login response missing token or user data");
                }
            } else {
                console.warn("Auto-login failed:", response.data?.message);
            }
        } catch (error) {
            console.error("Error during auto-login:", error);
        }
    };

    const handleShowFunction = () => {
    setShowAcctModal(true);
    setShowSuccessModal(false);
    };




    const handlePaystackClick = async (e) => {
        e.preventDefault();

        if (paymentMethod === "wallet") {
            // Handle wallet payment
            const amountToPay = parseFloat(planAmount.replace(/[^0-9.-]+/g, ''));
            if (isNaN(amountToPay)) {
                Swal.fire("Error", "Invalid plan amount.", "error");
                return;
            }

            if (walletBalance < amountToPay) {
                Swal.fire("Insufficient Balance", "Your wallet balance is not enough to complete this payment.", "error");
                return;
            }

            // Deduct from wallet
            const newBalance = walletBalance - amountToPay;
            setWalletBalance(newBalance);
            localStorage.setItem("walletBalance", newBalance.toString());

            // Set success summary
            const summary = {
                plan: selectedPlan?.name || planName,
                amountPaid: planAmount,
                billing: "Monthly",
            };
            setSuccessSummary(summary);

            try {
                localStorage.setItem("hasPaidPlan", "true");
            } catch {}

            // setShowSuccessModal(true);
            handleShowSuccessModal();
            // Auto-login the user after successful payment
            void autoLoginUser({ redirectToDashboard: true });
            return;
        }

        // Ensure Paystack is selected as the payment method
        if (paymentMethod !== "paystack") {
            Swal.fire("Payment Method", "Please select 'Pay with Paystack' to continue.", "warning");
            return;
        }

        // Try multiple token sources: authToken, token, or from location state
        const token = 
            localStorage.getItem("authToken") || 
            localStorage.getItem("token") ||
            location.state?.token;
        
        if (!token) {
            console.error("Authentication token not found. Available localStorage keys:", Object.keys(localStorage));
            Swal.fire("Not Logged In", "You must be logged in to make a payment. Please complete company registration first.", "error");
            return;
        }
        
        console.log("Using token for payment authentication");

        // Show processing modal immediately
        setShowPaystackModal(true);
        const startTime = Date.now();

        try {
            const payload = {
                plan_id: selectedPlan?.id,
                plan_name: selectedPlan?.name,
            };

            const res = await axios.post(`${BASE_URL}/v1/pay-package`, payload, {
                headers: {
                    Authorization: `Bearer ${token}`,
                    Accept: "application/json",
                    "Content-Type": "application/json",
                },
            });

            const data = res?.data || {};
            const isSuccess = data?.status === true || data?.success === true;
            const backendMessage =
                (typeof data?.message === "string" && data.message) ||
                (typeof data?.msg === "string" && data.msg) ||
                "";
            const checkoutUrl = typeof data?.data === "string" ? data.data : "";

            const minProcessingTime = 2000; // 2s
            const elapsed = Date.now() - startTime;
            if (elapsed < minProcessingTime) {
                await new Promise((resolve) => setTimeout(resolve, minProcessingTime - elapsed));
            }

            if (isSuccess) {
                if (!checkoutUrl) {
                    setShowPaystackModal(false);
                    await Swal.fire(
                        "Payment Initialization Failed",
                        backendMessage || "No checkout link was returned. Please try again.",
                        "error"
                    );
                    return;
                }

                // Persist summary so we can show it after Paystack redirects back.
                try {
                    localStorage.setItem(
                        "pendingPaymentSummary",
                        JSON.stringify({
                            plan: selectedPlan?.name || planName,
                            amountPaid: planAmount,
                            billing: "Monthly",
                        })
                    );
                } catch {
                    // ignore
                }

                // Redirect user to Paystack checkout.
                window.location.assign(checkoutUrl);
            } else {
                setShowPaystackModal(false);
                await Swal.fire(
                    "Payment Failed",
                    backendMessage || "Payment could not be completed. Please try again.",
                    "error"
                );
            }
        } catch (error) {
            console.error("Error initiating Paystack package payment:", error);
            const errMsg =
                error?.response?.data?.message ||
                error?.response?.data?.msg ||
                error?.message ||
                "Failed to initiate payment. Please try again.";
            await Swal.fire("Error", errMsg, "error");
        } finally {
            // Ensure processing modal is closed in case of early failures
            setShowPaystackModal(false);
        }
    };

    const handleNavigateToManualEntry = () => {
        const companyId = location.state?.company_id || localStorage.getItem("company_id") || localStorage.getItem("activeCompanyId");
        navigate('/manual-opening-bal', {
            state: {
                accounts: rows,
                company_id: companyId,
                industryId: location.state?.industryId,
                selectedPlan: location.state?.selectedPlan,
            }
        });
    };

    const handleDownloadTemplate = async (e) => {
    e.preventDefault();
    e.stopPropagation();

    try {
        setDownloadingTemplate(true);

        const url = `https://sme-api.brookessoftware.com/api/v1/download-opening-balance?company_id=${companyId}&industry_id=${industryID}`;

        const response = await fetch(url, {
            method: "GET",
        });

        if (!response.ok) {
            throw new Error("Failed to download template");
        }

        const blob = await response.blob();

        const downloadUrl = window.URL.createObjectURL(blob);

        const link = document.createElement("a");
        link.href = downloadUrl;
        link.download = "opening-balance-template.xlsx";

        document.body.appendChild(link);
        link.click();

        link.remove();
        window.URL.revokeObjectURL(downloadUrl);

    } catch (error) {
        console.error(error);
    } finally {
        setDownloadingTemplate(false);
    }
};

const handleFileSelect = (e) => {
  const file = e.target.files[0];

  if (file) {
    setSelectedFile(file);
    setSelectedFileName(file.name);
  }
};


  const uploadStatement = async (file) => {
    setCreateLoading(true);    
    const token = localStorage.getItem("authToken");
    try {    
      const formData = new FormData();
      formData.append('file', file);
      formData.append('transaction_date', selectedDate);
    const companyId = location.state?.company_id || localStorage.getItem("company_id") || localStorage.getItem("activeCompanyId");
    if (companyId) formData.append('company_id', companyId);
      const response = await axios.post(
        `${BASE_URL}/v1/account/upload-opening-balance`,
        formData,
        {
          headers: {
            'Content-Type': 'multipart/form-data',
            'Authorization': `Bearer ${token}`
          }
        }
      );

      console.log(response, "heeee");
      const openingBalances = response.data?.data || [];
      setBalances(openingBalances);
    //   await localStorage.setItem("openingBalance", JSON.stringify(openingBalances));
      Swal.fire({
        icon: 'success',
        title: 'Successful',
        text: response.data.message,
      });
      navigate('/confirm-opening-bal', {
        state: {
          balances: openingBalances,
        }
      });

    } catch (error) {
      let errorMessage = 'An error occurred. Please try again.';
      if (error.response && error.response.data && error.response.data.message) {
        if (typeof error.response.data.message === 'string') {
          errorMessage = error.response.data.message;
        } else if (Array.isArray(error.response.data.message)) {
          errorMessage = error.response.data.message.join('; ');
        } else if (typeof error.response.data.message === 'object') {
          errorMessage = JSON.stringify(error.response.data.message);
        }
        Swal.fire({
          icon: 'error',
          title: 'Failed',
          text: JSON.stringify(error.response.data.message),
        });
      }
      console.error(error);
    } finally {
  //   setTimeout(() => {
  //   setCreateLoading(false);
  // }, 4000);
      setCreateLoading(false);
    }
  };


    return (
        <div>
            <div className={classes.vitchri}>
                <div>
                    <img src={promix} />
                </div>

                <div className={classes.busy}>
                    <p className={classes.gate}>Features</p>
                    <p className={classes.gate}>Pricing</p>
                    <p className={classes.gate}>Resources</p>

                    <button className={classes.bu_tton}>Start Free Trial</button>
                </div>
            </div>

            <div className={classes.pirates}>Upload Your Opening Balances
            </div>

            <p className={classes.ship}>Choose how you'd like to enter your balances — download our Excel<br/> template to fill offline, or type them in directly on screen</p>

            <div style={{ padding: '40px 20px', maxWidth: '900px', margin: '0 auto', alignItems: 'center', display: 'flex', flexDirection: 'column', gap: 35 }}>
                <div style={{ display: "flex", justifyContent: "center", gap: 48 }}>
                    <div className={classes.templateCard} onClick={ () => setShowDownloadExcel(true)}>
                        <div>
                            <div className={classes.templateTitle}>
                                <img src={excelIcon} />
                                <h3>Upload via Excel</h3>
                            </div>
                        </div>
                        <div>
                            <p className={classes.templateDesc}>Download our ready-made template, fill in your balances offline at your own pace, then re-upload when you're done</p>
                        </div>
                    </div>       
                
                    <div className={classes.templateCard} onClick={handleNavigateToManualEntry}>
                        <div className={classes.templateTitle}>
                            <img src={manualIcon} />
                            <h3>Enter Manually</h3>
                        </div>
                        <div>
                            <p className={classes.templateDesc}>Type your opening balances directly on screen, account by account. Best if you have just a few accounts to update</p>
                        </div>
                    </div>
                </div>
                <p>Not ready yet? You can <button onClick={() => {
                                    navigate('/dashboard', {
                                        replace: true,
                                        state: {
                                            from: location.pathname,
                                        }
                                    });
                                }} className={classes.skipLink}>skip</button> this step and complete your chart of accounts anytime from your dashboard</p>
                    </div>

            {showDownloadExcel && (
                <div className={classes.paystack_overlay} onClick={() => setShowDownloadExcel(false)}>
                <div
                    className={classes.showDownloadExcelModal}
                    onClick={(e) => e.stopPropagation()}
                >
                    {/* <div className={classes.showDownloadExcelModal} onClick={() => setShowDownloadExcel(false)}> */}
                        <div className={classes.exitWrap} aria-hidden="true">
                            <div className={classes.downloadHeader}>
                                <h6>Download Excel Template</h6>
                                <p>Three steps to get your opening balances in</p>
                            </div>
                            <img src={exitIcon} alt="Exit Icon" className={classes.exitIcon} onClick={() => setShowDownloadExcel(false)}/>
                        </div>
                       
                        <div className={classes.uploadTemplateBox} aria-hidden="true">
                            <div
                                className={classes.uploadFile}
                                onClick={handleDownloadTemplate}
                            >
                                {downloadingTemplate ? (
                                    <Spinner animation="border" size="md" />
                                ) : (
                                    <img
                                        src={downloadTemplate}
                                        alt="Download Template"
                                        className={classes.uploadTemplate}
                                    />
                                )}

                                <p style={{ fontSize: "14px" }}>
                                    <b>opening_balances_template.xlsx</b>
                                </p>

                                <br />

                                <p>
                                    Download our ready-made template, fill in your balances offline at your
                                    <br />
                                    own pace, then re-upload when you're done
                                </p>
                            </div>
                            <div className={classes.subInstruction}>
                                <img
                                src={checkBox}
                                alt="Upload Template"
                                className={classes.checkBox}
                                />

                                <p style={{ fontSize: "11px" }}>Click Download Template — your accounts will already be listed <br /> in the spreadsheet</p>
                            </div>
                            <div className={classes.subInstruction}>
                                <img
                                src={checkBox}
                                alt="Upload Template"
                                className={classes.checkBox}
                                />

                                <p style={{ fontSize: "11px" }}>Open the file and fill in the Opening Balance column for each <br /> account</p>
                            </div>
                            <div className={classes.subInstruction}>
                                <img
                                src={checkBox}
                                alt="Upload Template"
                                className={classes.checkBox}
                                />
                                <p style={{ fontSize: "11px" }}>Come back here and upload the completed file to import all your <br /> balances at once</p>
                            </div>

                        </div>
                        <div className={classes.importActions}>

                            <button
                                className={classes.cancelBtnDownload}
                                onClick={() => {
                                    setShowUploadExcel(true);
                                    setShowDownloadExcel(false);
                                }}
                            >
                                <img
                                src={upIgo}
                                alt="Upload Template"
                                className={classes.checkBox}
                                />
                                <p style={{ fontSize: "11px" }}>Upload Document</p>
                            </button>
                            <button
                                className={classes.importButNew}
                                onClick={() => {
                                    setShowDeclinedModal(false);
                                    setPaymentMethod("");
                                }}
                            >
                                <img
                                src={downloadgo}
                                alt="Upload Template"
                                className={classes.checkBox}
                                />
                                <p style={{ fontSize: "11px" }}>Download Template</p>
                                {/* Upload Document */}
                            </button>
                        </div>
                    </div>
                </div>
            )}

            {showUploadExcel && (
                <div className={classes.paystack_overlay} onClick={() => setShowUploadExcel(false)}>
                <div
                    className={classes.showUploadExcelModal}
                    onClick={(e) => e.stopPropagation()}
                >
                    {/* <div className={classes.showDownloadExcelModal} onClick={() => setShowDownloadExcel(false)}> */}
                        <div className={classes.exitWrap} aria-hidden="true">
                            <div className={classes.downloadHeader}>
                                <h6>Download Excel Template</h6>
                                <p>Two steps to get your opening balances in</p>
                            </div>
                            <img src={exitIcon} alt="Exit Icon" className={classes.exitIcon} onClick={() => setShowUploadExcel(false)}/>
                        </div>
                       
                        <div className={classes.uploadTemplateBox} aria-hidden="true">
                            <div className={classes.downloadTemplate}>
                                <img src={checkBox} alt="Download Template" className={classes.checkBox} />
                                <p style={{ textAlign: "left" }}>Template downloaded - now select a transaction date and <br />upload your completed file below </p>
                            <input
                            type="date"
                            value={selectedDate}
                            onChange={(e) => setSelectedDate(e.target.value)}
                            required
                            />
                            </div>
                            <div
                            className={classes.uploadFile}
                            onClick={() => document.getElementById("openingBalanceFile").click()}
                            >
                            <input
                                type="file"
                                id="openingBalanceFile"
                                accept=".xlsx,.xls,.csv"
                                style={{ display: "none" }}
                                onChange={handleFileSelect}
                            />

                            <div className={classes.subUploadFile}>
                                <img
                                src={uploadTemplate}
                                alt="Upload Template"
                                className={classes.uploadTemplate}
                                />

                                <p>
                                {selectedFileName
                                    ? selectedFileName
                                    : "Click to upload your completed file"}
                                </p>
                            </div>

                            <p>or drag and drop .xlsx, .xls, .csv accepted</p>
                            </div>
                        </div>
                        <div className={classes.importActions}>
                            <button
                                className={classes.cancelBut}
                                onClick={() => {
                                    setShowUploadExcel(false);
                                    setShowDownloadExcel(true);
                                }}
                            >
                                Cancel
                            </button>
                            <button
                            className={classes.ImportBut}
                            onClick={async () => {
                                if (!selectedFile) {
                                Swal.fire({
                                    icon: "warning",
                                    title: "No file selected",
                                    text: "Please select a file first",
                                });
                                return;
                                }

                                await uploadStatement(selectedFile);
                            }}
                            >
                                {createLoading ? (
                                    <>
                                    <Spinner animation="border" size="sm" /> 
                                    <span style={{ marginLeft: "5px" }}>Uploading...</span>
                                    </>
                                ) : (
                                    "Import & Review" 
                                )}
                            </button>
                        </div>
                    </div>
                </div>
            )}

            {showAccountDetailsModal && (
                <div className={classes.paystack_overlay}>
                    <div className={classes.success_modal} style={{maxWidth: '400px'}}>
                        <p className={classes.success_title}>Account Details</p>
                        <p className={classes.success_subtitle}>Use these details to fund your wallet via bank transfer</p>

                        <div style={{border: '1px solid #ddd', padding: '15px', borderRadius: '5px', backgroundColor: '#f9f9f9', margin: '20px 0'}}>
                            <p style={{fontSize: '14px', margin: '5px 0'}}><strong>Account Name:</strong> {accountDetails.accountName}</p>
                            <p style={{fontSize: '14px', margin: '5px 0'}}><strong>Account Number:</strong> {accountDetails.accountNumber}</p>
                            <p style={{fontSize: '14px', margin: '5px 0'}}><strong>Bank:</strong> {accountDetails.bank}</p>
                        </div>

                        <div style={{margin: '20px 0px 0px 0px ', textAlign: 'center'}}>
                            <p style={{fontSize: '14px'}}>I have funded wallet</p>
                        </div>

                        <button className={classes.declined_primary} onClick={() => setShowAccountDetailsModal(false)}>
                            Close
                        </button>
                    </div>
                </div>
            )}

            {/* <p className={classes.proeterw}>Trusted by 10,000+ businesses worldwide</p>
            <div className={classes.pitfall}>
                <div className={classes.number_num}>
                    <p className={classes.costat}>₦50B+</p>
                    <p className={classes.prethelr}>Processed Monthly</p>
                </div>
                <div className={classes.number_num}>
                    <p className={classes.costat}>99.9%</p>
                    <p className={classes.prethelr}> Uptime SLA</p>
                </div>
                <div className={classes.number_num}>
                    <p className={classes.costat}>500+</p>
                    <p className={classes.prethelr}>Integrations</p>
                </div>
            </div> */}
        </div>

    )
}

export default UploadOpeningBal;
